export default __webpack_public_path__ + "static/media/bckspc-logo-y2k.2a075c52.png";